import { useUserEventLogger } from '@repo/tracking-service';
import { TopNavigation } from '@zenterprise-inc/ui';
import cn from 'clsx';
import { useRouter } from 'next/router';

import s from '@/components/my/common/layout.module.scss';

export const MyRefundHistoryTopNavigation = () => {
  const { back } = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goBack = () => {
    sendClickEvent('history_topnav_back');
    back();
  };

  return <TopNavigation.Basic leftIcon={'back'} onLeftClick={goBack} className={cn(s.nav_position, 'bg-gray-50')} />;
};
